// 入门级开发工具相关API
import request from '@/api'

// 入门级开发工具-删除场景
export async function delScene(data) {
  return request({
    url: '/capi/scene-service/scene/sceneController/delScene',
    method: 'post',
    data
  })
}
// 入门级开发工具-全部列表
export async function selectDirectoryList(data) {
  return request({
    url: '/capi/scene-service/scene/directory/selectDirectoryList',
    method: 'post',
    data
  })
}
// 入门级开发工具-克隆
export async function cloneScene(data) {
  return request({
    url: '/capi/scene-service/scene/sceneController/cloneScene',
    method: 'post',
    data
  })
}
// 场景移动
export async function sceneMove(data) {
  return request({
    url: '/capi/scene-service/scene/sceneController/sceneMove',
    method: 'post',
    data
  })
}
// 入门级开发工具-场景修改
export async function addOrUpdateScene(data) {
  return request({
    url: `/capi/scene-service/scene/sceneController/addOrUpdateScene/${data.uesType}`,
    method: 'post',
    data
  })
}
// 入门级开发工具-创建、修改目录
export async function addOrUpdateDirectory(data) {
  return request({
    url: `/capi/scene-service/scene/directory/addOrUpdateDirectory/${data.uesType}`,
    method: 'post',
    data
  })
}
// 入门级开发工具-删除目录
export async function delDirectory(data) {
  return request({
    url: '/capi/scene-service/scene/directory/delDirectory',
    method: 'post',
    data
  })
}
// 入门级开发工具-查询目录下信息
export async function selectDirectoryAllList(data) {
  return request({
    url: '/capi/scene-service/scene/directory/selectDirectoryAllList',
    method: 'post',
    data
  })
}
// 入门级开发工具-查询目录列
export async function selectDirectoryColumn(data) {
  return request({
    url: '/capi/scene-service/scene/directory/selectDirectoryColumn',
    method: 'post',
    data
  })
}
// 入门级开发工具-查询目录列
export async function selectCatalogue(data) {
  return request({
    url: '/capi/scene-service/scene/directory/selectCatalogue',
    method: 'post',
    data
  })
}
// 入门级开发工具-提交/取消测试
export async function testScene(data) {
  return request({
    url: '/capi/scene-service/scene/sceneController/testScene',
    method: 'post',
    data
  })
}
// 入门级开发工具-获取流程状态
export async function getTestSceneInfo(data) {
  return request({
    url: '/capi/scene-service/scene/sceneController/getTestSceneInfo',
    method: 'post',
    data
  })
}
// 入门级开发工具-选择场景
export async function selectScene(data) {
  return request({
    url: '/capi/scene-service/scene/sceneController/selectScene',
    method: 'post',
    data
  })
}

// 查询用户下所有场景总数
export async function getSceneTotal(data) {
  return request({
    url: '/capi/scene-service/scene/sceneController/getSceneTotal',
    method: 'post',
    data
  })
}

// 查询用户下所有场景总数
export async function makeOperationStr(data) {
  return request({
    url: '/capi/scene-service/scene/as/makeReqStr',
    method: 'post',
    data
  })
}
// 发布取消
export async function releaseScene(data) {
  return request({
    url: '/capi/scene-service/scene/sceneController/releaseScene',
    method: 'post',
    data
  })
}
// 入门级开发工具-发送验证码
export async function sendCodeByEmail(data) {
  return request({
    url: `/capi/web-service/uaes/commons/sendMail`,
    method: 'post',
    data
  })
}
// 入门级开发工具-验证码校验
export async function verifyCodeByEmail(data) {
  return request({
    url: `/capi/web-service/uaes/commons/verifyCode`,
    method: 'post',
    data
  })
}
// 重新开发
export async function backDevelopScene(data) {
  return request({
    url: '/capi/scene-service/scene/sceneController/backDevelopScene',
    method: 'post',
    data
  })
}
// 重新发布
export async function releaseSceneAgain(data) {
  return request({
    url: '/capi/scene-service/scene/sceneController/releaseSceneAgain',
    method: 'post',
    data
  })
}
